export function getFileExtension(filename: string | undefined) {
  if (!filename) return;
  return filename.split('.').pop()?.toLowerCase();
}